import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col order-quotable q-mr-md" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  class: "col column justify-center",
  style: {"min-width":"150px"}
}

import { Ref, ref, inject, watch } from 'vue';
import { useRouter } from 'vue-router';
import countOrderQuotableKey from '../../common/order-quotable-key';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderQuotableButton',
  emits: ['deleteSidebar'],
  setup(__props, { emit: __emit }) {

const router = useRouter();

const emit = __emit;

// 注文件数
const orderCnt = inject<Ref<number>>('orderCnt');

// 問い合わせ件数
const quotableCnt = inject<Ref<number>>('quotableCnt');

// パンチアウトタイプ
const poType = inject('poType');

// 注文件数アニメーションフラグ
const orderAnimationFlg = ref<boolean>(false);

// 問い合わせ件数アニメーションフラグ
const quotableAnimationFlg = ref<boolean>(false);

const sleep = (second: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, second * 1000);
  });

// 注文問い合わせ件数取得
const countOrderQuotable = inject(countOrderQuotableKey);

/**
 * 注文問い合わせ画面遷移
 */
const orderQuotable = () => {
  emit('deleteSidebar');
  router.push({ name: 'orderInquiry' });
};

// 初期表示処理
countOrderQuotable?.();

// 注文件数が変更されたか監視
watch(
  () => orderCnt?.value,
  async () => {
    orderAnimationFlg.value = true;
    await sleep(2);
    orderAnimationFlg.value = false;
  }
);

// 問い合わせ件数が変更されたか監視
watch(
  () => quotableCnt?.value,
  async () => {
    quotableAnimationFlg.value = true;
    await sleep(2);
    quotableAnimationFlg.value = false;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass('col ' + (orderAnimationFlg.value ? 'order-quotable-trasform' : ''))
        }, [
          _cache[0] || (_cache[0] = _createElementVNode("label", null, "注文： ", -1)),
          _createElementVNode("span", null, _toDisplayString(_unref(orderCnt)), 1)
        ], 2),
        (_unref(poType) === 'PO_NORMAL')
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass('col ' + (quotableAnimationFlg.value ? 'order-quotable-trasform' : ''))
            }, [
              _cache[1] || (_cache[1] = _createElementVNode("label", null, "問い合わせ： ", -1)),
              _createElementVNode("span", null, _toDisplayString(_unref(quotableCnt)), 1)
            ], 2))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_q_btn, {
        class: "order-quotable-btn",
        label: _unref(poType) === 'PO_NORMAL' ? '注文/問い合わせ' : 'ChemPanda カート',
        style: _normalizeStyle(
          _unref(poType) === 'PO_NORMAL'
            ? 'min-width: 150px; text-transform: none'
            : 'min-width: 162px; text-transform: none'
        ),
        onClick: orderQuotable
      }, null, 8, ["label", "style"])
    ])
  ]))
}
}

})